import { render, staticRenderFns } from "./y_detail.vue?vue&type=template&id=3a166b7f&scoped=true&"
import script from "./y_detail.vue?vue&type=script&lang=js&"
export * from "./y_detail.vue?vue&type=script&lang=js&"
import style0 from "./y_detail.vue?vue&type=style&index=0&id=3a166b7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a166b7f",
  null
  
)

export default component.exports